module.exports = __webpack_public_path__ + "img/dyp03.7a62b83e.jpg";